import React, { useEffect, useState } from "react";
import "../../../../Assets/CSS/bulkorder.css";
import "../../oms.css";
import Up from "../../../../Assets/Images/OMS/up.svg";
import Down from "../../../../Assets/Images/OMS/down.svg";
import { useFormik } from "formik";
import moment from "moment";
import AccountBox from "@mui/icons-material/AccountBox";

function BuyerDetailsForm({ omsData }) {
  const [buyerDetails, setBuyerDetails] = useState(false);

  const validate = (values) => {
    const errors = {};
    if (!values.supplier_Name) {
      errors.supplier_Name = " Supplier name is required";
    } else if (values.supplier_Name.length > 35) {
      errors.firstName = "Must be 35 characters or less";
    }

    return errors;
  };

  const initialValues = {
    buyer_name: "",
    field_executive: "",
    billed_to: "",
    ordered_date: "",
    billing_address: "",
    city_state: "",
    pincode: "",
    gst_number: "",
    pan: "",
    contact_no: "",
    bank_ac_no: "",
    reenter_bank_no: "",
    branch: "",
    ifsc_code: "",
    commodity_name: null,
    supplier_invoice_number: null,
    supplier_invoice_date: null,
    loaded_weight_in_qtl: null,
    rate_in_qtl: null,
    total_invoice_value: null,
  };

  const formik = useFormik({
    initialValues: initialValues,
    validate,
    onSubmit: (values) => {
      console.log(values);
    },
  });

  useEffect(() => {
    formik.setValues({
      ...formik.values,
      buyer_name: omsData?.buyer?.first_name
        ? `${omsData?.buyer?.first_name} ${omsData?.buyer?.last_name}`
        : "NA",
      billed_to: omsData?.buyer?.shop?.name ? omsData?.buyer?.shop?.name : "NA",
      field_executive: omsData?.buyer?.relationship_manager?.rm_name
        ? omsData?.buyer?.relationship_manager?.rm_name
        : "NA",
      ordered_date: omsData?.ordered_date
        ? moment(omsData?.ordered_date).format("DD-MM-YYYY")
        : "NA",
      billing_address: omsData?.buyer?.shop?.billing_address
        ? omsData?.buyer?.shop?.billing_address
        : "NA",

      city_state: omsData?.buyer?.shop?.city
        ? `${omsData?.buyer?.shop?.city}/${omsData?.buyer?.shop?.state}`
        : "NA",
      pincode: omsData?.buyer?.shop?.pin_code
        ? omsData?.buyer?.shop?.pin_code
        : "NA",
      gst_number: omsData?.buyer?.user_kyc?.gst_number
        ? omsData?.buyer?.user_kyc?.gst_number
        : "NA",
      pan: omsData?.buyer?.user_kyc?.pan_card
        ? omsData?.buyer?.user_kyc?.pan_card
        : "NA",
      contact_no: omsData?.buyer?.mobile_number
        ? omsData?.buyer?.mobile_number
        : "",
      bank_ac_no: omsData?.buyer?.user_kyc?.bank_account_no
        ? omsData?.buyer?.user_kyc?.bank_account_no
        : "",
      branch: omsData?.buyer?.user_kyc?.bank_branch_name
        ? omsData?.buyer?.user_kyc?.bank_branch_name
        : "",
      ifsc_code: omsData?.buyer?.user_kyc?.bank_ifsc_code
        ? omsData?.buyer?.user_kyc?.bank_ifsc_code
        : "",
      commodity_name: omsData?.op_sourcing_details?.[0]?.commodity_name
        ? omsData?.op_sourcing_details?.[0]?.commodity_name
        : "NA",
      supplier_invoice_number: omsData?.op_sourcing_details?.[0]
        ?.supplier_invoice_number
        ? omsData?.op_sourcing_details?.[0]?.supplier_invoice_number
        : "NA",
      supplier_invoice_date: omsData?.op_sourcing_details?.[0]
        ?.supplier_invoice_date
        ? omsData?.op_sourcing_details?.[0]?.supplier_invoice_date
        : "NA",
      loaded_weight_in_qtl: omsData?.op_sourcing_details?.[0]
        ?.loaded_weight_in_qtl
        ? omsData?.op_sourcing_details?.[0]?.loaded_weight_in_qtl
        : 0,
      rate_in_qtl: omsData?.op_sourcing_details?.[0]?.rate_in_qtl
        ? omsData?.op_sourcing_details?.[0]?.rate_in_qtl
        : 0,
      total_invoice_value: omsData?.op_sourcing_details?.[0]?.total_invoice_value
        ? omsData?.op_sourcing_details?.[0]?.total_invoice_value
        : 0,
    });
  }, [omsData, formik.setValues]);

  return (
    <div className="shadow-lg m-2 p-2 pb-2 rounded-lg">
      <div className="flex flex-col sm:flex-row justify-between">
        <div className="font-medium text-cyan-950 text-md flex gap-2">
          <AccountBox />
          <div> Buyer Details</div>
        </div>
        <div>
          {buyerDetails ? (
            <div className="font-medium text-cyan-950 text-lg mt-2">
              <img
                src={Up}
                alt=""
                role="button"
                onClick={() => setBuyerDetails(!buyerDetails)}
              />
            </div>
          ) : (
            <div className="font-medium text-cyan-950 text-lg mt-2">
              <img
                src={Down}
                alt=""
                role="button"
                onClick={() => setBuyerDetails(!buyerDetails)}
              />
            </div>
          )}
        </div>
      </div>
      <div>
        <hr className="font-bold text-neutral-500 bg-gray-900 h-0.5" />
      </div>
      <div>
        {buyerDetails ? (
          <></>
        ) : (
          <div>
            <form onSubmit={formik.handleSubmit}>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2">
                <div>
                  <label
                    for="buyer_name"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                  >
                    Buyer Name
                  </label>
                  <input
                    type="text"
                    id="buyer_name"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="buyer_name"
                    value={formik.values.buyer_name}
                    disabled
                  />
                  {formik.errors.buyer_name ? (
                    <div className="text-red-600 text-sm flex justify-start ms-1">
                      {formik.errors.buyer_name}
                    </div>
                  ) : null}
                </div>
                <div>
                  <label
                    for="billed_to"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                  >
                    Billed To
                  </label>
                  <input
                    type="text"
                    id="billed_to"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="billed_to"
                    value={formik.values.billed_to}
                    disabled
                  />
                  {formik.errors.billed_to ? (
                    <div className="text-red-600 text-sm flex justify-start ms-1">
                      {formik.errors.billed_to}
                    </div>
                  ) : null}
                </div>
                <div>
                  <label
                    for="field_executive"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                  >
                    Field Executive
                  </label>
                  <input
                    type="text"
                    id="field_executive"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="field_executive"
                    value={formik.values.field_executive}
                    disabled
                  />
                  {formik.errors.field_executive ? (
                    <div className="text-red-600 text-sm flex justify-start ms-1">
                      {formik.errors.field_executive}
                    </div>
                  ) : null}
                </div>
                <div>
                  <label
                    for="ordered_date"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                  >
                    Ordered Date
                  </label>
                  <input
                    type="text"
                    id="ordered_date"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="ordered_date"
                    value={formik.values.ordered_date}
                    disabled
                  />
                  {formik.errors.ordered_date ? (
                    <div className="text-red-600 text-sm flex justify-start ms-1">
                      {formik.errors.ordered_date}
                    </div>
                  ) : null}
                </div>

                <div>
                  <label
                    for="city_state"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                  >
                    City/State
                  </label>
                  <input
                    type="text"
                    id="city_state"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="city_state"
                    value={formik.values.city_state}
                    disabled
                  />
                  {formik.errors.city_state ? (
                    <div className="text-red-600 text-sm flex justify-start ms-1">
                      {formik.errors.city_state}
                    </div>
                  ) : null}
                </div>
                <div>
                  <label
                    for="pincode"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                  >
                    Pin Code
                  </label>
                  <input
                    type="text"
                    id="pincode"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="pincode"
                    value={formik.values.pincode}
                    disabled
                  />
                  {formik.errors.pincode ? (
                    <div className="text-red-600 text-sm flex justify-start ms-1">
                      {formik.errors.pincode}
                    </div>
                  ) : null}
                </div>
                <div>
                  <label
                    for="gst_number"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                  >
                    GST Number
                  </label>
                  <input
                    type="text"
                    id="gst_number"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="gst_number"
                    value={formik.values.gst_number}
                    disabled
                  />
                  {formik.errors.gst_number ? (
                    <div className="text-red-600 text-sm flex justify-start ms-1">
                      {formik.errors.gst_number}
                    </div>
                  ) : null}
                </div>
                <div>
                  <label
                    for="pan"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                  >
                    PAN
                  </label>
                  <input
                    type="text"
                    id="pan"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="pan"
                    value={formik.values.pan}
                    disabled
                  />
                  {formik.errors.pan ? (
                    <div className="text-red-600 text-sm flex justify-start ms-1">
                      {formik.errors.pan}
                    </div>
                  ) : null}
                </div>
                <div>
                  <label
                    for="contact_no"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                  >
                    Contact No
                  </label>
                  <input
                    type="text"
                    id="contact_no"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="contact_no"
                    value={formik.values.contact_no}
                    disabled
                  />
                  {formik.errors.contact_no ? (
                    <div className="text-red-600 text-sm flex justify-start ms-1">
                      {formik.errors.contact_no}
                    </div>
                  ) : null}
                </div>
                <div>
                  <label
                    for="bank_ac_no"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                  >
                    Bank Ac No
                  </label>
                  <input
                    type="text"
                    id="bank_ac_no"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="bank_ac_no"
                    value={formik.values.bank_ac_no}
                    disabled
                  />
                  {formik.errors.bank_ac_no ? (
                    <div className="text-red-600 text-sm flex justify-start ms-1">
                      {formik.errors.bank_ac_no}
                    </div>
                  ) : null}
                </div>
                <div>
                  <label
                    for="branch"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                  >
                    Branch
                  </label>
                  <input
                    type="text"
                    id="branch"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="branch"
                    value={formik.values.branch}
                    disabled
                  />
                  {formik.errors.branch ? (
                    <div className="text-red-600 text-sm flex justify-start ms-1">
                      {formik.errors.branch}
                    </div>
                  ) : null}
                </div>
                <div>
                  <label
                    for="ifsc_code"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                  >
                    IFSC Code
                  </label>
                  <input
                    type="text"
                    id="ifsc_code"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="ifsc_code"
                    value={formik.values.ifsc_code}
                    disabled
                  />
                  {formik.errors.ifsc_code ? (
                    <div className="text-red-600 text-sm flex justify-start ms-1">
                      {formik.errors.ifsc_code}
                    </div>
                  ) : null}
                </div>

                {/* ----------------------- New changes ---------------------------------- */}
                <div>
                  <label
                    htmlFor="commodity_name"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                  >
                    Commodity
                  </label>
                  <input
                    type="text"
                    id="commodity_name"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="commodity_name"
                    value={formik.values.commodity_name}
                    disabled
                  />
                </div>
                <div>
                  <label
                    htmlFor="Buyer Invoice Number"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                  >
                    Buyer Invoice Number
                  </label>
                  <input
                    type="text"
                    id="supplier_invoice_number"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="supplier_invoice_number"
                    value={formik.values.supplier_invoice_number}
                    disabled
                  />
                </div>
                <div>
                  <label
                    htmlFor="buyer_invoice_date"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                  >
                    Buyer Invoice Date
                  </label>
                  <input
                    type="date"
                    id="supplier_invoice_date"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="supplier_invoice_date"
                    value={
                      formik.values.supplier_invoice_date /
                      formik.values.supplier_invoice_date
                        ? new Date(formik.values.supplier_invoice_date)
                        : ""
                    }
                    disabled
                  />
                </div>
                <div>
                  <label
                    htmlFor="loaded_weight_in_qtl"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                  >
                    Loaded Weight in QTL
                  </label>
                  <input
                    type="number" onWheel={(e) => e.target.blur()}
                    id="loaded_weight_in_qtl"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="loaded_weight_in_qtl"
                    value={formik.values?.loaded_weight_in_qtl}
                    disabled
                  />
                </div>
                <div>
                  <label
                    htmlFor="rate_in_qtl"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                  >
                    Rate per Qtl
                  </label>
                  <input
                    type="number" onWheel={(e) => e.target.blur()}
                    id="rate_in_qtl"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="rate_in_qtl"
                    value={formik.values?.rate_in_qtl}
                    disabled
                  />
                </div>
                <div>
                  <label
                    htmlFor="total_invoice_value"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                  >
                    Total invoice Value
                  </label>
                  <input
                    type="number" onWheel={(e) => e.target.blur()}
                    id="total_invoice_value"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="total_invoice_value"
                    value={formik.values?.total_invoice_value}
                    disabled
                  />
                </div>
                <div>
                  <label
                    htmlFor="billing_address"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                  >
                    Billing Address
                  </label>
                  <textarea
                    id="billing_address"
                    rows="4"
                    class="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    value={formik.values.billing_address.replace(/@@/g, "")}
                    disabled
                    name="billing_address"
                  ></textarea>
                </div>
              </div>
              {/* <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-3 mt-2 ">
                <div>
                  <label
                    for="branch"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                  >
                    Add Documents
                  </label>
                  <Button
                    sx={{ backgroundColor: "gray" }}
                    variant="contained"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  >
                    <CloudUploadIcon />
                    <b className="ms-2 mt-1">Upload Documents</b>
                  </Button>
                </div>
              </div> */}
            </form>
          </div>
        )}
      </div>
    </div>
  );
}

export default BuyerDetailsForm;
